import React from "react";

/* The control context (workspace-control-group-rail-controls, design-system
   programme wave 7). Engine tier and not in the barrel, so every tier can read
   it: a WorkspaceControlGroup with `railControls` provides "rail", and Button
   (atoms) reads it to paint the chrome-control rail and primary looks from
   lib/chrome-control.ts (PresenceCluster keeps its own look). Without a provider the
   value is null and every part renders today's look.

   React context crosses portals, so a part that portals content out of the
   group resets the value to null: PopoverContent, ModalShell and Tooltip
   content do. A new portal part must reset it too, or a Button in its panel
   takes the rail look. */

/** "rail" inside a rail group; null everywhere else. */
export type ControlContextValue = "rail" | null;

export const ControlContext = React.createContext<ControlContextValue>(null);

/** The enclosing control context, or null outside a rail group. */
export function useControlContext(): ControlContextValue {
  return React.useContext(ControlContext);
}
